<template>
  <div class="placeholder">
    <div class="placeholder-inner">
      <GoblinIcon
        variant="empty"
        size="88"
        class="placeholder-goblin"
        :label="`${title} — coming soon`"
      />
      <div class="placeholder-title-row">
        <component :is="icon" v-if="icon" :size="22" aria-hidden="true" class="placeholder-icon" />
        <h1 class="placeholder-title">{{ title }}</h1>
      </div>
      <p class="placeholder-blurb">
        {{ blurb || 'The goblin is still building this — check back soon.' }}
      </p>
      <span class="placeholder-tag">Coming soon</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import GoblinIcon from '../components/GoblinIcon.vue';

withDefaults(
  defineProps<{
    /** Section name shown as the heading (e.g. "Dashboards"). */
    title: string;
    /** The rail's lucide icon for this section, rendered beside the title. */
    icon?: unknown;
    /** One-line "this is being built" note; a sensible default is used if omitted. */
    blurb?: string;
  }>(),
  { icon: undefined, blurb: '' },
);
</script>

<style scoped>
.placeholder {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: var(--lg-space-6) var(--lg-space-4);
}
.placeholder-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: var(--lg-space-3);
  max-width: 420px;
}
.placeholder-goblin {
  color: var(--lg-text-faint);
  opacity: 0.7;
}
.placeholder-title-row {
  display: inline-flex;
  align-items: center;
  gap: var(--lg-space-2);
  color: var(--lg-text);
}
.placeholder-icon {
  color: var(--lg-accent);
}
.placeholder-title {
  margin: 0;
  font-size: var(--lg-fs-xl);
  font-weight: 600;
}
.placeholder-blurb {
  margin: 0;
  font-size: var(--lg-fs-md);
  color: var(--lg-text-dim);
}
.placeholder-tag {
  font-size: var(--lg-fs-2xs);
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: var(--lg-text-faint);
  border: 1px solid var(--lg-border);
  border-radius: var(--lg-radius-pill);
  padding: 2px var(--lg-space-2);
}
</style>
